const NAVBAR_HEIGHT = '80px'

export { NAVBAR_HEIGHT }
